import { render, staticRenderFns } from "./singleLineTextStyle.vue?vue&type=template&id=01b3661b&scoped=true"
import script from "./singleLineTextStyle.vue?vue&type=script&lang=js"
export * from "./singleLineTextStyle.vue?vue&type=script&lang=js"
import style0 from "./singleLineTextStyle.vue?vue&type=style&index=0&id=01b3661b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3661b",
  null
  
)

export default component.exports